var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "download",
    d: "M6.75-14h2.5a.723.723,0,0,1,.531.219A.723.723,0,0,1,10-13.25V-8h2.75a.564.564,0,0,1,.563.391.575.575,0,0,1-.125.672l-4.75,4.75A.6.6,0,0,1,8-2a.6.6,0,0,1-.437-.187l-4.75-4.75a.575.575,0,0,1-.125-.672A.564.564,0,0,1,3.25-8H6v-5.25a.723.723,0,0,1,.219-.531A.723.723,0,0,1,6.75-14ZM16-2.25v3.5a.723.723,0,0,1-.219.531A.723.723,0,0,1,15.25,2H.75a.723.723,0,0,1-.531-.219A.723.723,0,0,1,0,1.25v-3.5a.723.723,0,0,1,.219-.531A.723.723,0,0,1,.75-3H5.344L6.875-1.469A1.534,1.534,0,0,0,8-1a1.534,1.534,0,0,0,1.125-.469L10.656-3H15.25a.723.723,0,0,1,.531.219A.723.723,0,0,1,16-2.25ZM11.938.938a.6.6,0,0,0,0-.875.6.6,0,0,0-.875,0,.6.6,0,0,0,0,.875.6.6,0,0,0,.875,0Zm2,0a.6.6,0,0,0,0-.875.6.6,0,0,0-.875,0,.6.6,0,0,0,0,.875.6.6,0,0,0,.875,0Z",
    transform: "translate(0 14)",
    fill: "#5d6373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.1ea64245c7930a1975ce379a868cb580.svg";
export { ForwardRef as ReactComponent };